"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDeliveryHandler = updateDeliveryHandler;
var _updateDeliveryFailed = require("@ori-events/update-delivery-failed");
var _requestOptions = require("../constants/requestOptions");
var _types = require("../types");
var _utils = require("../utils");
async function updateDeliveryHandler({
  detail: {
    deliveryAddressId,
    deliveryChannelId,
    registrationId
  }
}) {
  // if needed, start with delivery channel ID update
  if (typeof deliveryChannelId !== 'undefined') {
    const channelRequestOptions = {
      ..._requestOptions.putRequestOptions,
      body: JSON.stringify({
        deliveryChannelId
      })
    };
    const channelResponse = await fetch(_types.RequestUrl.UpdateDeliveryChannel, channelRequestOptions);
    const channelResponseData = (0, _utils.convertToCamelCase)(await channelResponse.json());
    if ((0, _updateDeliveryFailed.isUpdateDeliveryErrorResponse)(channelResponseData)) {
      const errorEvent = new CustomEvent(_updateDeliveryFailed.Name, {
        detail: channelResponseData
      });
      window.dispatchEvent(errorEvent);
      return false;
    }
  }

  // delivery address ID update
  const addressParams = {
    addressId: deliveryAddressId
  };
  if (registrationId) {
    addressParams.registrationId = registrationId;
  }
  const addressRequestOptions = {
    ..._requestOptions.putRequestOptions,
    body: JSON.stringify(addressParams)
  };
  const addressResponse = await fetch(_types.RequestUrl.UpdateDeliveryAddress, addressRequestOptions);
  const addressResponseData = (0, _utils.convertToCamelCase)(await addressResponse.json());
  if ((0, _updateDeliveryFailed.isUpdateDeliveryErrorResponse)(addressResponseData)) {
    const errorEvent = new CustomEvent(_updateDeliveryFailed.Name, {
      detail: addressResponseData
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return addressResponseData;
}
